import React, { useState } from 'react';
import { AlertTriangleIcon, TrashIcon, ArchiveIcon, LoaderIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { knowledgeSpaceService } from '../../../services/knowledge-space';
import { toast } from 'sonner';
interface Props {
  spaceId: string;
}
export const DangerZone = ({
  spaceId
}: Props) => {
  const navigate = useNavigate();
  const [showArchiveConfirm, setShowArchiveConfirm] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const handleArchive = async () => {
    try {
      setIsProcessing(true);
      await knowledgeSpaceService.archive(spaceId);
      toast.success('Knowledge Space archived successfully');
      navigate('/dashboard');
    } catch (error) {
      toast.error('Failed to archive Knowledge Space');
    } finally {
      setIsProcessing(false);
      setShowArchiveConfirm(false);
    }
  };
  const handleDelete = async () => {
    try {
      setIsProcessing(true);
      await knowledgeSpaceService.delete(spaceId);
      toast.success('Knowledge Space deleted successfully');
      navigate('/dashboard');
    } catch (error) {
      toast.error('Failed to delete Knowledge Space');
    } finally {
      setIsProcessing(false);
      setShowDeleteConfirm(false);
    }
  };
  return <div className="space-y-6 bg-surface-light border border-surface-border p-6 rounded-none" data-id="element-1263">
      <div className="flex items-center gap-3 text-status-error" data-id="element-1264">
        <AlertTriangleIcon size={20} data-id="element-1265" />
        <h3 className="text-lg font-medium font-mono" data-id="element-1266">Danger Zone</h3>
      </div>
      <div className="space-y-4" data-id="element-1267">
        {/* Archive Space */}
        <div className="p-4 border border-surface-border bg-surface" data-id="element-1268">
          <div className="flex items-start justify-between gap-4" data-id="element-1269">
            <div data-id="element-1270">
              <h4 className="text-sm font-medium text-white font-mono mb-1" data-id="element-1271">
                Archive Knowledge Space
              </h4>
              <p className="text-sm text-gray-400" data-id="element-1272">
                Archive this space and all its contents. This action can be
                reversed.
              </p>
            </div>
            {!showArchiveConfirm ? <button onClick={() => setShowArchiveConfirm(true)} className="px-4 py-2 bg-surface-light border border-surface-border text-white text-sm font-mono hover:bg-surface-mid transition-colors rounded-none" data-id="element-1273">
                Archive
              </button> : <div className="flex items-center gap-2" data-id="element-1274">
                <button onClick={() => setShowArchiveConfirm(false)} disabled={isProcessing} className="px-4 py-2 bg-surface-light border border-surface-border text-gray-400 text-sm font-mono hover:text-white transition-colors rounded-none disabled:opacity-50" data-id="element-1275">
                  Cancel
                </button>
                <button onClick={handleArchive} disabled={isProcessing} className="px-4 py-2 bg-surface-light border border-surface-border text-white text-sm font-mono hover:bg-surface-mid transition-colors rounded-none flex items-center gap-2 disabled:opacity-50" data-id="element-1276">
                  {isProcessing ? <LoaderIcon size={16} className="animate-spin" data-id="element-1277" /> : <ArchiveIcon size={16} data-id="element-1278" />}
                  <span data-id="element-1279">Confirm Archive</span>
                </button>
              </div>}
          </div>
        </div>
        {/* Delete Space */}
        <div className="p-4 border border-status-error/30 bg-status-error/10" data-id="element-1280">
          <div className="flex items-start justify-between gap-4" data-id="element-1281">
            <div data-id="element-1282">
              <h4 className="text-sm font-medium text-status-error font-mono mb-1" data-id="element-1283">
                Delete Knowledge Space
              </h4>
              <p className="text-sm text-gray-400" data-id="element-1284">
                Permanently delete this space and all its contents. This action
                cannot be undone.
              </p>
            </div>
            {!showDeleteConfirm ? <button onClick={() => setShowDeleteConfirm(true)} className="px-4 py-2 bg-status-error/20 text-status-error text-sm font-mono hover:bg-status-error/30 transition-colors rounded-none" data-id="element-1285">
                Delete
              </button> : <div className="flex items-center gap-2" data-id="element-1286">
                <button onClick={() => setShowDeleteConfirm(false)} disabled={isProcessing} className="px-4 py-2 bg-surface-light border border-surface-border text-gray-400 text-sm font-mono hover:text-white transition-colors rounded-none disabled:opacity-50" data-id="element-1287">
                  Cancel
                </button>
                <button onClick={handleDelete} disabled={isProcessing} className="px-4 py-2 bg-status-error text-white text-sm font-mono hover:bg-status-error/90 transition-colors rounded-none flex items-center gap-2 disabled:opacity-50" data-id="element-1288">
                  {isProcessing ? <LoaderIcon size={16} className="animate-spin" data-id="element-1289" /> : <TrashIcon size={16} data-id="element-1290" />}
                  <span data-id="element-1291">Confirm Delete</span>
                </button>
              </div>}
          </div>
        </div>
      </div>
    </div>;
};